/* Static shell (nav, footer, lightbox) of the approved artist page template (03 Website Redesign/artist.html). */
export const ARTIST_HTML = `
<nav id="nav">
  <a class="logo" href="/"><b class="neon">TRIP INK</b><small>TATTOO &middot; LAS VEGAS</small></a>
  <div class="links">
    <a href="/#crew">The Crew</a><a class="opt" href="/#vault">The Vault</a><a href="/#lot">Up for Grabs</a><a href="#work">The Work</a><a class="opt" href="#concepts">Concepts</a><a href="/#faq">FAQ</a><a href="#visit">Visit</a>
  </div>
  <div class="navr">
    <a class="btn sm solid" id="navBook" href="#" data-book>Book</a>
    <button class="burger" id="burger" aria-label="Menu">&#9776;</button>
  </div>
</nav>

<main id="page"></main>

<footer class="visit" id="visit">
  <div class="bigname" aria-hidden="true">TRIP INK</div>
  <div class="head rv"><div class="bulbrow" data-n="7"></div><span class="eyebrow">Come find us</span><h2 class="title neon">Visit</h2></div>
  <div class="cols">
    <div class="rv">
      <h4>Address</h4>
      <div class="addr">5115 Dean Martin Drive #906<br>Las Vegas, NV 89118
        <small>Front entrance to Hot Rod City. Look for the red neon.</small></div>
      <div class="cta"><a class="btn sm solid" href="https://www.google.com/maps/search/?api=1&query=5115+Dean+Martin+Drive+906+Las+Vegas+NV+89118" target="_blank" rel="noopener">Get Directions</a></div>
    </div>
    <div class="rv contact" style="--d:.1s">
      <h4>Reach Us</h4>
      <a href="tel:702-605-6633"><b>CALL</b>702-605-6633</a>
      <a href="tel:702-586-5308"><b>WALK-IN</b>702-586-5308</a>
      <a href="sms:702-408-8305"><b>TEXT</b>702-408-8305</a>
      <a href="mailto:tripinklv@gmail.com"><b>EMAIL</b>tripinklv@gmail.com</a>
      <div class="social"><a class="btn sm" href="https://www.instagram.com/tripinktattoo/" target="_blank" rel="noopener">Instagram</a><a class="btn sm" href="https://www.facebook.com/tripinktattoo/" target="_blank" rel="noopener">Facebook</a></div>
    </div>
    <div class="rv" style="--d:.2s">
      <h4>Hours</h4>
      <ul><li><span>Mon &ndash; Wed</span><span>12pm &ndash; 8pm</span></li><li><span>Thu &ndash; Sun</span><span>1pm &ndash; 10pm</span></li></ul>
      <p style="margin-top:.9em;font-size:.9em;color:#b9b4bd;line-height:1.5">Hours may vary. Call <a href="tel:702-586-5308" style="color:#ffe2a3;white-space:nowrap">702-586-5308</a> to check availability.</p>
    </div>
  </div>
  <div class="copy"><span>&copy; Trip Ink Tattoo Company. Las Vegas, NV. &middot; <a href="/release-form">Release form</a> &middot; <a href="/shop">Shop</a> &middot; <a href="/artist-interview">Artists: profile interview</a></span></div>
</footer>

<nav class="actbar" aria-label="Quick actions"><a href="tel:702-605-6633">Call</a><a href="sms:702-408-8305">Text</a><a class="solid" id="barBook" href="#" data-book>Book</a></nav>

<dialog class="lb" id="lb" aria-label="Photo viewer">
  <div class="lb-in">
    <div class="lb-top"><span><span class="kind" id="lbKind">Real work</span> &middot; <span id="lbNum">1 / 1</span></span><button class="lbx" id="lbX" aria-label="Close">&times;</button></div>
    <div class="lb-stage" id="lbStage">
      <button class="lbn p" id="lbP" aria-label="Previous photo">&#8592;</button>
      <img id="lbImg" alt="">
      <button class="lbn n" id="lbN" aria-label="Next photo">&#8594;</button>
    </div>
    <div class="lb-bot"><div class="lb-cap"><b id="lbT"></b><span id="lbS"></span></div><a class="btn sm solid" id="lbBook" href="#" data-book>Book</a></div>
  </div>
</dialog>
`;
